if (!customElements.get('store-info')) {
  class StoreInfo extends HTMLElement {
    connectedCallback() {
      this.days = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ]

      this.storeBusinessHoursScript = document.getElementById('store_business_hours_data')
      this.storeHolidaysScript = document.getElementById('store_holiday_data')

      if (!this.storeBusinessHoursScript) return

      this.storeBusinessHours = JSON.parse(this.storeBusinessHoursScript.textContent)
      this.storeHolidays = JSON.parse(this.storeHolidaysScript?.textContent)

      this.currentDateAndTime = new Date()
      this.today = this.days[this.currentDateAndTime.getDay()] // 0-6
      this.businessHoursToday = this.storeBusinessHours.find(day => day.name === this.today)

      if (this.storeHolidays.length) {
        this.applyHolidays(this.formatDate(this.currentDateAndTime))
      } else {
        this.setCurrentDay()
        this.setStatus()
      }
    }

    setCurrentDay = (useHolidayHours=false, holiday={}) => {
      const dayElement = this.querySelector(`.store-info-business-hours-day--${this.today}`)
      if (dayElement) {
        dayElement.classList.add('font-bold')
      }

      if (useHolidayHours) {
        const hoursElement = dayElement.querySelector(".store-info-business-hours-day__hours")

        if (!hoursElement) return

        if (holiday.closedAllDay) {
          hoursElement.innerHTML = "Closed"
          return
        }

        const openTime = new Date()
        openTime.setHours(holiday?.openHour, holiday?.openMinute, 0)
        const openTimeString = openTime.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

        const closeTime = new Date()
        closeTime.setHours(holiday?.closeHour, holiday?.closeMinute, 0)
        const closeTimeString = closeTime.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

        hoursElement.innerHTML = `${openTimeString} - ${closeTimeString}`
      }
    }

    setStatus = (useHolidayHours=false, holiday={}) => {
      const schedule = useHolidayHours ? holiday : this.businessHoursToday

      const openTime = new Date()
      openTime.setHours(schedule?.openHour, schedule?.openMinute, 0)

      const closeTime = new Date()
      closeTime.setHours(schedule?.closeHour, schedule?.closeMinute, 0)

      const statusParentElement = this.querySelector('#store_info_status')
      const statusMsgElement = statusParentElement?.querySelector(".store-info-content__status__msg")

      if (!statusParentElement || !statusMsgElement) return

      const setToClosed = (currentDayTime=null) => {
        statusParentElement.classList.add("store-info-content__status--closed")
        let nextOpenTime
        
        if (currentDayTime === "beforeOpen") {
          nextOpenTime = schedule
          nextOpenTime.name = "" // if current time is before the shop opens, then don't show the "next" day
        } else {
          nextOpenTime = this.getNextOpenDay()
        }

        openTime.setHours(nextOpenTime?.openHour, nextOpenTime?.openMinute, 0)
        statusMsgElement.innerHTML = `Closed Now - Opens at ${openTime.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })} <span class="capitalize">${nextOpenTime.name}</span>`
        return
      }

      if (schedule.closedAllDay) {
        setToClosed()
        return
      }

      if (this.currentDateAndTime >= openTime && this.currentDateAndTime <= closeTime) {
        statusParentElement.classList.add("store-info-content__status--open")
        statusMsgElement.innerHTML = "Open Now"
      } else {
        if (this.currentDateAndTime < openTime) {
          setToClosed("beforeOpen")
        }

        if (this.currentDateAndTime > closeTime) {
          setToClosed("afterClose")
        }
      }
    }

    getNextOpenDay = () => {
      const getHolidayForDate = (date) => {
        return this.storeHolidays?.find(_holiday => (
          this.isHolidayMatch(_holiday, this.parseDate(_holiday.date), date)
        ))
      }

      const todayIndex = this.storeBusinessHours.findIndex(day => day.name === this.today)
      let nextDayIndex = todayIndex + 1
      let nextDate = new Date()
      nextDate.setDate(nextDate.getDate() + 1)

      if (nextDayIndex === this.storeBusinessHours.length) {
        nextDayIndex = 0
      }

      let nextDay = this.storeBusinessHours[nextDayIndex]
      let holiday = getHolidayForDate(nextDate)
      let nextDayIsClosedAllDay = holiday ? holiday.closedAllDay : nextDay.closedAllDay
      let nextOpenDay = holiday && !holiday.closedAllDay
        ? { ...nextDay, openHour: holiday.openHour, openMinute: holiday.openMinute, closeHour: holiday.closeHour, closeMinute: holiday.closeMinute }
        : nextDay
      let loopCount = 0

      while (nextDayIsClosedAllDay && loopCount < 7) {
        nextDayIndex += 1
        nextDate.setDate(nextDate.getDate() + 1)

        if (nextDayIndex === this.storeBusinessHours.length) {
          nextDayIndex = 0
        }

        nextDay = this.storeBusinessHours[nextDayIndex]
        holiday = getHolidayForDate(nextDate)
        nextDayIsClosedAllDay = holiday ? holiday.closedAllDay : nextDay.closedAllDay

        if (!nextDayIsClosedAllDay) {
          nextOpenDay = holiday
            ? { ...nextDay, openHour: holiday.openHour, openMinute: holiday.openMinute, closeHour: holiday.closeHour, closeMinute: holiday.closeMinute }
            : nextDay
        }

        loopCount++
      }

      return nextOpenDay
    }

    applyHolidays = (currentDateString) => {
      if (!currentDateString) return

      const today = this.parseDate(currentDateString)

      const startOfWeek = new Date()
      startOfWeek.setDate(today.getDate() - today.getDay())
      startOfWeek.setHours(0, 0, 0, 0)

      const endOfWeek = new Date(startOfWeek)
      endOfWeek.setDate(endOfWeek.getDate() + 6)
      endOfWeek.setHours(23, 59, 59, 999)

      let todayIsHoliday = {status: false, holiday: {}}

      this.storeHolidays.forEach(holiday => {
        const holidayDate = this.parseDate(holiday.date)

        if (this.isHolidayMatch(holiday, holidayDate, this.currentDateAndTime)) {
          const todayDayIndex = holiday.repeating ? this.currentDateAndTime.getDay() : holidayDate.getDay()
          holiday.dayName = this.days[todayDayIndex]
          todayIsHoliday.status = true
          todayIsHoliday.holiday = holiday
        }

        const occurrenceInWeek = this.getOccurrenceInRange(holiday, holidayDate, startOfWeek, endOfWeek)

        if (occurrenceInWeek) {
          const dayIndex = occurrenceInWeek.getDay()

          const selector = `.store-info-business-hours-day--${this.days[dayIndex]} .store-info-business-hours-day__hours`
          const dayElement = this.querySelector(selector)

          if (!dayElement) return

          if (holiday.closedAllDay) {
            dayElement.innerHTML = "Closed"
            return
          }

          const holidayOpenTime = new Date()
          holidayOpenTime.setHours(holiday.openHour, holiday.openMinute, 0)
          const holidayOpenTimeString = holidayOpenTime.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

          const holidayCloseTime = new Date()
          holidayCloseTime.setHours(holiday.closeHour, holiday.closeMinute, 0)
          const holidayCloseTimeString = holidayCloseTime.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

          dayElement.textContent = `${holidayOpenTimeString} - ${holidayCloseTimeString}`
        }
      })

      if (todayIsHoliday.status) {
          this.setCurrentDay(true, todayIsHoliday.holiday)
          this.setStatus(true, todayIsHoliday.holiday)
      } else {
        this.setCurrentDay()
        this.setStatus()
      }
    }

    getOccurrenceForYear = (date, year) => new Date(year, date.getMonth(), date.getDate())

    isHolidayMatch = (holiday, holidayDate, targetDate) => {
      if (holiday.repeating) {
        return holidayDate.getMonth() === targetDate.getMonth() && holidayDate.getDate() === targetDate.getDate()
      }
      return holidayDate.toDateString() === targetDate.toDateString()
    }

    getOccurrenceInRange = (holiday, holidayDate, startOfRange, endOfRange) => {
      if (!holiday.repeating) {
        return (holidayDate >= startOfRange && holidayDate <= endOfRange) ? holidayDate : null
      }

      const candidateYears = [startOfRange.getFullYear() - 1, startOfRange.getFullYear(), startOfRange.getFullYear() + 1]

      for (const year of candidateYears) {
        const occurrence = this.getOccurrenceForYear(holidayDate, year)
        if (occurrence >= startOfRange && occurrence <= endOfRange) {
          return occurrence
        }
      }

      return null
    }

    parseDate = (dateString) => {
      if (!dateString) return

      const [y, m, d] = dateString.split("-").map(string => Number(string))
      return new Date(y, m - 1, d) // month (m) is 0-based, e.g. 8-1 is August (7)
    }

    formatDate = (date) => {
      const y = date.getFullYear()
      const m = date.getMonth() + 1
      const d = date.getDate()
      return `${y}-${m}-${d}`
    }
  }

  customElements.define('store-info', StoreInfo)
}
